import { Modal, Form, Input, Button, message } from 'antd';
import { ApartmentOutlined, IdcardOutlined } from '@ant-design/icons';
import { useState } from 'react';
import s from './index.module.css';
import { forgotPassword } from '../../server/api';

const ForgotPasswordModal = ({ open, onCancel }) => {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  const handleSubmit = async (values) => {
    setLoading(true);
    try {
      await forgotPassword({
        name: values.orgName,
        creditCode: values.creditCode,
      });
      message.success('重置链接已发送到您的邮箱，请查收！');
      form.resetFields();
      onCancel();
    } catch (error) {
      console.error('发送重置链接失败:', error);
      message.error('发送失败，请检查机构名称和社会信用代码是否正确');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title="忘记密码"
      open={open}
      onCancel={() => {
        form.resetFields();
        onCancel();
      }}
      footer={null}
      width={400}
      className={s.forgotModal}
      destroyOnClose={true}
    >
      <p className={s.forgotTip}>
        确认重置后，重置链接将发送到您的注册邮箱，请正确填写以下信息：
      </p>
      <Form
        form={form}
        name="forgotPassword"
        onFinish={handleSubmit}
        autoComplete="off"
        layout="vertical"
      >
        <Form.Item
          name="orgName"
          label="机构名称"
          rules={[{ required: true, message: '请输入机构名称' }]}
        >
          <Input
            prefix={<ApartmentOutlined />}
            placeholder="请输入机构名称"
            size="large"
          />
        </Form.Item>

        <Form.Item
          name="creditCode"
          label="18位社会信用代码"
          rules={[
            { required: true, message: '请输入18位社会信用代码' },
            { len: 18, message: '社会信用代码为18位' },
          ]}
        >
          <Input
            prefix={<IdcardOutlined />}
            placeholder="请输入18位社会信用代码"
            size="large"
            maxLength={18}
          />
        </Form.Item>

        <Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            loading={loading}
            size="large"
            block
            className={s.submitButton}
          >
            确认重置
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ForgotPasswordModal;
